export const XmlHttpRequest = (controller) => {
  Object.assign(controller, {
    xmlHttpRequest: () => ({
      "X-Requested-With": "XMLHttpRequest",
    }),
  });
};
